<template>
    <v-container fluid>
        <UsedcarBanner></UsedcarBanner>
        <UsedcarTable></UsedcarTable>
    </v-container>
</template>
<script>
import UsedcarBanner from '../components/ui/UsedcarBanner.vue'
import UsedcarTable from '../components/ui/UsedcarTable.vue'
export default {
  name: "Usedcar",
  components: {
      UsedcarBanner,
      UsedcarTable
  },
  data: () => ({
      tab: null,
      tabItems: [
        '소형', '중형', '고급', '승합',
      ]
  }),
};
</script>
<style scoped>
</style>
